<div class="pending-container" [ngClass]="containerClasses">
    <div class="document-queue">
        <!-- Queue documents behind -->
        <div class="queue-document queue-doc-5"></div>
        <div class="queue-document queue-doc-4"></div>
        <div class="queue-document queue-doc-3"></div>
        <div class="queue-document queue-doc-2"></div>
        <div class="queue-document queue-doc-1"></div>
        <!-- Main document -->
        <div class="document"></div>
    </div>
    @if (showText) {
    <div class="pending-text">{{ text }}</div>
    }

    <!-- Content projection slot for custom templates -->
    <ng-content></ng-content>
</div>
